import {useSelector} from 'react-redux';

import {useGetAutoDeliveryDetailsExtendedDcx} from '@/api/consumerApi';
import {selectLanguageCode} from '@/state/selectors/global';
import dateTimeUtils from '@/utils/dateTimeUtils';
import {normalizeApiDate} from '@/utils/normalizeApiDate';
import stringUtils from '@/utils/stringUtils';

import AutoDeliveryResultPopup from '../../../components/AutoDeliveryResultPopup';
import {getRescheduleContent} from '../utils/getRescheduleContent';
import RescheduleSelectionSummaryCard from './RescheduleSelectionSummaryCard';

interface RescheduleSuccessPopupProps {
    onClose: () => void;
}

const RescheduleSuccessPopup = ({onClose}: RescheduleSuccessPopupProps) => {
    const languageCode = useSelector(selectLanguageCode);
    const {data} = useGetAutoDeliveryDetailsExtendedDcx();
    const {successPopup, dateDayPluralForms} = getRescheduleContent() || {};
    const frequency = data?.autoDelivery?.frequency;
    const {nextOrderMinStartDate, nextOrderMaxStartDate} = data?.order || {};
    const nextDeliveryDate = normalizeApiDate(data?.autoDelivery?.nextDeliveryDate);
    const nextOrderMinDate = normalizeApiDate(nextOrderMinStartDate);
    const nextOrderMaxDate = normalizeApiDate(nextOrderMaxStartDate);

    if (!successPopup) {
        return null;
    }

    const {description} = successPopup;
    const descriptionFormatted =
        description && nextDeliveryDate
            ? stringUtils.formatString(
                  description,
                  nextDeliveryDate.toLocaleDateString(languageCode, {weekday: 'long'}),
                  dateTimeUtils.getOrdinalDay(nextDeliveryDate.getDate(), dateDayPluralForms, languageCode),
                  dateTimeUtils.getMonth(nextDeliveryDate, languageCode)
              )
            : description;

    return (
        <AutoDeliveryResultPopup
            popup={successPopup}
            description={descriptionFormatted}
            onClose={onClose}
            onButtonClick={onClose}
        >
            {nextOrderMinDate && nextOrderMaxDate && (
                <RescheduleSelectionSummaryCard
                    className='mt-2'
                    selectedFrequency={frequency}
                    minDate={nextOrderMinDate}
                    maxDate={nextOrderMaxDate}
                />
            )}
        </AutoDeliveryResultPopup>
    );
};

export default RescheduleSuccessPopup;
